import feedbackFactory from './feedbackFactory'
import registerStore from './registerStore'

export default {
  install (app, { delay = 5000, storeName = 'cfeedbacks', store } = {}) {
    if (!store) {
      console.error('ConveniaFeedbacks: Vuex store argument missing')
      return false
    }

    if (!store.hasModule(storeName)) {
      registerStore(store, storeName, delay)
      store.dispatch('FEEDBACK_DELAY', delay)
    }

    app.config.globalProperties.$feedback = feedbackFactory({ $store: store })
  }
}
